import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { USER_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class UserRepoMappingService {
  private readonly MASTER_API = `${USER_URL}/userRepoMapping`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  public getReportingManagers(countryId: number): Observable<any> {
    return this.http
      .get<any>(`${this.MASTER_API}/getReportingManagers?countryId=${countryId}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getPromotersMappingDetails(countryId: number, managerId?: number, searchFilter?: string, pageIndex?: number, pageSize?: number): Observable<any> {
    let params = new HttpParams().set('countryId', countryId.toString());
    if (managerId) {
      params = params.set('managerId', managerId.toString());
    }
    if (searchFilter) {
      params = params.set('searchFilter', searchFilter);
    }
    if (pageIndex !== undefined) {
      params = params.set('pageIndex', pageIndex.toString());
    }
    if (pageSize !== undefined) {
      params = params.set('pageSize', pageSize.toString());
    }
    return this.http
      .get<any>(`${this.MASTER_API}/getPromotersMappingDetails`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public updateSingleMapping(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.MASTER_API}/updateSingle`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public downloadTemplate(countryId: number, managerId?: number, searchFilter?: string): Observable<any> {
    let params = new HttpParams().set('countryId', countryId.toString());
    if (managerId) {
      params = params.set('managerId', managerId.toString());
    }
    if (searchFilter) {
      params = params.set('searchFilter', searchFilter);
    }
    return this.http
      .get<any>(`${this.MASTER_API}/downloadTemplate`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public updateBulkMappings(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.MASTER_API}/updateBulk`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAuditLogs(countryId: number, managerId?: number, searchFilter?: string, pageIndex?: number, pageSize?: number): Observable<any> {
    let params = new HttpParams().set('countryId', countryId.toString());
    if (managerId) {
      params = params.set('managerId', managerId.toString());
    }
    if (searchFilter) {
      params = params.set('searchFilter', searchFilter);
    }
    if (pageIndex !== undefined) {
      params = params.set('pageIndex', pageIndex.toString());
    }
    if (pageSize !== undefined) {
      params = params.set('pageSize', pageSize.toString());
    }
    return this.http
      .get<any>(`${this.MASTER_API}/getAuditLogs`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }
}
